import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import NavigationBar from "../components/layout/NavigationBar";
import CustomToolBar from "../components/layout/CustomToolBar";
import Footer from "../components/layout/Footer";
import DealsContainer from "./dealsContainer";
import JustPrisaContainer from "./justPrisaContainer";
import HaklaiContainer from "./haklaiContainer";
import MyDealsContainerNoSP from "./myDealsContainerNoSP";
import UsersManagement from "../components/managerComponents/usersManagement";
import AdminRoute from "../auth/adminGuard";
import SalesRoute from "../auth/salesGuard";
import AdminContainer from "./adminContainer";
import { isFeatureEnabled } from "../services/utils/featureAccess";

class ApplicationCon extends Component {
  render() {
    const hasHaklaiAccess = isFeatureEnabled(this.props.enabledFeatures, "BTAX_HAKLAI_DEALS");
    const isHaklaiRoute = this.props.location?.pathname?.startsWith("/haklai/");

    return (
      <React.Fragment>
        <NavigationBar />
        <CustomToolBar hideOnSmallScreens={isHaklaiRoute} />
        <div className="container pb-70 pt-70 center">
          <Switch>
            <Route path="/my-deals" component={MyDealsContainerNoSP} />
            <Route path="/deal/:tab/:dealId" component={DealsContainer} />
            <Route path="/just-prisa/:tab/:dealId" component={JustPrisaContainer} />
            {hasHaklaiAccess ? (
              <Route path="/haklai/:tab/:dealId" component={HaklaiContainer} />
            ) : (
              <Route path="/haklai/:tab/:dealId">
                <Redirect to="/my-deals" />
              </Route>
            )}
            <SalesRoute path="/users-management/:searchByCardNum?" component={UsersManagement} />
            <AdminRoute path="/admin" component={AdminContainer} />
            <Route path="/">
              <Redirect to="/my-deals" />
            </Route>
          </Switch>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    enabledFeatures: state.loggedinReducer.enabledFeatures
  };
};

export default connect(mapStateToProps)(ApplicationCon);
